<template>
  <div class="messages-tasks-widget-container">
    <table class="messages-tasks-widget-table">
      <thead>
        <tr>
          <th>Type</th>
          <th>From</th>
          <th>To</th>
          <th>Item</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="5" class="messages-tasks-widget-empty">No records to show</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import './styles/MessagesTasksWidget.css';

export default {
  name: 'MessagesTasksWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

